import { getTemplateRequestGQLQuery, getTemplatesGQLQuery, } from '../../graphql/index.js';
export class TemplatesClient {
    constructor(client) {
        this.client = client;
    }
    async list(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getTemplatesGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.templates;
    }
    async templateRequest(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getTemplateRequestGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.templateRequest;
    }
}
//# sourceMappingURL=templates.client.js.map